import React from "react";
import "./PopUpComponent.css";

const PopUpComponent = ({ children, style, small, scroll }) => {
  return (
    <div
      className="container_popup_component"
      style={scroll ? { overflowY: "scroll" } : {}}
    >
      <div
        className={
          small
            ? "wrapper_popup_component width_popup"
            : "wrapper_popup_component"
        }
        style={style}
      >
        {children}
      </div>
    </div>
  );
};
export default PopUpComponent;
